import { render, staticRenderFns } from "./ShopsDaily.vue?vue&type=template&id=9105869c&"
import script from "./ShopsDaily.vue?vue&type=script&lang=ts&"
export * from "./ShopsDaily.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports